// extracted by mini-css-extract-plugin
export default {"loading":"int_loa_20Lao"};